export const normalizeEmailInput = (value: string): string =>
  value.trim().toLowerCase()

export const normalizeOptionalEmailInput = (value: string): string | null => {
  const normalized = normalizeEmailInput(value)
  return normalized || null
}

export const normalizePhoneInput = (value: string): string =>
  value.trim()
